export default () => {
    if ($('.location-page__main__amenities').length === 0) {
        return;
    }
    $('.location-page__main__amenities__items--accordion').hide();

    $('#see-more-amenities').on('click', function () {
        $(this).toggleClass('location-page__main__amenities__see-more--active');
        $('.location-page__main__amenities__items--accordion').slideToggle();
        $('.location-page__main__amenities__items--accordion').toggleClass('location-page__main__amenities__items--accordion-active');

        // Update button text based on active state
        if ($(this).hasClass('location-page__main__amenities__see-more--active')) {
            $(this).html('Hide amenities <i></i>'); // Update text to "Hide"
        } else {
            $(this).html('See all amenities <i></i>'); // Revert back to "See all"
        }
    });
}
